import React from 'react'

import { classNames } from '../../utils/dom'

const Notification = ({ Icon, children, className, ...props }) => (
  <div {...props} className={classNames(['notification', (className && className) || ''])}>
    <div className="notification-icon-wrap">
      { Icon &&
        <span className="notification-icon">
          <Icon />
        </span>
      }
      <p className="notification-with-icon notification-body">
        {children}
      </p>
    </div>
  </div>
)

export default Notification
